package com.karawek.core.auth.stytch

import com.karawek.core.auth.api.AuthCredentialType
import com.karawek.core.auth.api.AuthTokenProvider
import com.karawek.core.auth.stytch.client.StytchClient

/**
 * [AuthTokenProvider] backed by the platform Stytch client. Delegates to the
 * SDK's live session so the token attached to each request is never a stale,
 * login-time copy.
 */
class StytchAuthTokenProvider(
    private val stytchClient: StytchClient,
) : AuthTokenProvider {

    override suspend fun currentCredential(type: AuthCredentialType): String? =
        when (type) {
            AuthCredentialType.SessionJwt ->
                stytchClient.currentSessionJwt() ?: stytchClient.currentSessionToken()
            AuthCredentialType.SessionToken ->
                stytchClient.currentSessionToken()
        }
}

/** Fallback used when auth runs in local (offline) mode with no Stytch SDK. */
internal object NoOpAuthTokenProvider : AuthTokenProvider {
    override suspend fun currentCredential(type: AuthCredentialType): String? = null
}
